import { Button } from '@pesto/ui/components/Button';
import { Card, CardContent } from '@pesto/ui/components/Card';
import { Typography } from '@pesto/ui/components/Typography';
import { cn } from '@pesto/utils';
import { Cross1Icon } from '@radix-ui/react-icons';
import { EyeIcon, PhoneIcon, UserIcon } from 'lucide-react';

import { useRoleMimickingStore, UserRole } from '../../../stores/useRoleMimickingStore';

const MIMICKABLE_ROLES = [UserRole.SuperAdmin, UserRole.SupportAgent] as const;

const roleDropdown: Record<(typeof MIMICKABLE_ROLES)[number], { icon: React.ReactNode; label: string }> = {
  [UserRole.SuperAdmin]: {
    icon: <UserIcon className="h-4 w-4" />,
    label: 'Admin',
  },
  [UserRole.SupportAgent]: {
    icon: <PhoneIcon className="h-4 w-4" />,
    label: 'Support Agent',
  },
};

export const DevMenuComponent = () => {
  const { currentRole, isMimicking, setRole, reset } = useRoleMimickingStore();

  return (
    <Card className="animate-in slide-in-from-bottom-2 absolute bottom-16 left-0 min-w-72 border shadow-lg duration-200">
      <CardContent className="space-y-4 p-4">
        <div className="space-y-1">
          <Typography variant="body" className="font-medium">
            Development Tools
          </Typography>
          <Typography variant="bodySmall" className="text-muted-foreground">
            Dev/Test Environment
          </Typography>
        </div>

        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Typography variant="bodySmall" className="font-medium">
              View as Role
            </Typography>
            {isMimicking && (
              <Button variant="ghost" size="sm" onClick={reset} className="h-6 px-2">
                <Cross1Icon className="h-3 w-3" />
              </Button>
            )}
          </div>
          <div className="space-y-1">
            {MIMICKABLE_ROLES.map((role) => (
              <Button
                key={role}
                variant={currentRole === role ? 'primary' : 'ghost'}
                size="sm"
                onClick={() => setRole(role)}
                className={cn(
                  'h-8 w-full justify-start gap-2 text-sm',
                  currentRole === role && 'bg-primary text-primary-foreground',
                )}
              >
                {roleDropdown[role].icon}
                {roleDropdown[role].label}
                {currentRole === role && isMimicking && <EyeIcon className="ml-auto h-3 w-3" />}
              </Button>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
